// 크기 정할 때 사용하는 함수 -> 0 부터 1까지의 값을 넣어서 % 값 리턴

import { account_sms_default } from './account_sms_contents';
import { fetchGetApi, fetchPostApi } from './api';
import { getKorUclass } from './user_tools';
import { SetStateAction, lazy } from 'react';
import { drop_contents_start, drop_contents_end } from './attendance_sms_dropdown_setting';
import {
  BASE_URL,
  TableTypeKeys,
  TableDefaultSortKey,
  HyosungDisabledDates,
  VirtualAccountDisabledDates,
} from './constants';
import dayjs from 'dayjs';
import { isHyosungAccount, normalizeAccountProvider } from './account_provider';

// 1보다 큰 수일 경우 해당 값 리턴 -> 해당값은 px로 MUI에서 인식
export function transform(value: number) {
  return value <= 1 ? `${value * 100}%` : value;
}

// 수업 날짜 한글로 출력
export function setStudyDayText(nums: number[] | []) {
  const days: string[] = ['일', '월', '화', '수', '목', '금', '토'];
  const res = [];

  const tmp_nums: number[] = nums;
  const zero_idx = tmp_nums.indexOf(0);
  if (zero_idx >= 0) {
    tmp_nums.splice(zero_idx, 1);
    tmp_nums.push(0);
  }

  for (const x of tmp_nums) {
    res.push(days[x]);
  }

  return res.join(', ');
}

// 0000년 00월 00일
export function setLocaleDateString(date: Date | null, type: string): string {
  let new_date: Date | null;
  if (date !== null) {
    new_date = date;
  } else {
    new_date = new Date();
  }
  const y = new_date.getFullYear();
  const m = new_date.getMonth() + 1;
  const d = new_date.getDate();

  let res = '';

  if (type == 'kor') {
    res = `${y}년 ${Number(m) < 10 ? '0' + m : m}월 ${Number(d) < 10 ? '0' + d : d}일`;
  } else {
    res = `${y}${type}${Number(m) < 10 ? '0' + m : m}${type}${Number(d) < 10 ? '0' + d : d}`;
  }

  return res;
}

// 날짜 구하기
export function setAgoDate(type: string, gap: number, date?: Date) {
  const d = new Date();

  let start_date: Date = d;
  let end_date: Date = d;
  if (type == 'year') {
    start_date = new Date(`${new Date().getFullYear() + gap}-1-1`);
    if (start_date.getFullYear() == new Date().getFullYear()) {
      end_date = new Date();
    } else {
      end_date = new Date(`${start_date.getFullYear()}-12-31`);
    }
  } else if (type == 'month') {
    start_date = new Date(new Date(new Date().setMonth(new Date().getMonth() + gap)).setDate(1));
    if (start_date.getMonth() == new Date().getMonth()) {
      end_date = new Date();
    } else {
      end_date = new Date(new Date(new Date().setMonth(new Date().getMonth() + gap + 1)).setDate(0));
    }
  } else if (type == 'week') {
    start_date = new Date(new Date().setDate(new Date().getDate() + gap * 7));
    end_date = new Date(new Date().setDate(new Date().getDate() + gap * 7 + 7));
  } else if (type == 'date') {
    start_date = new Date(new Date().setDate(new Date().getDate() + gap));
    end_date = start_date;
  }

  return { start_date, end_date };
}

// 테스트
// 등록 버튼 등 disabled 상태 관리
export function setBtnDisabled(
  data: {
    [key: string]: {
      value: string;
      origin: string;
      require: boolean;
      [key: string]: string | boolean | undefined | object | number;
    };
  },
  type: string,
) {
  let require_num = 0;
  let comp_require_num = 0;
  let edit_num = 0;
  const edit_keys: string[] = [];
  for (const [key, val] of Object.entries(data)) {
    if (val.require) require_num++;
    if (val.require && val.value.length > 0) {
      if (type == 'add' && val.key == 'rcheckday' && typeof val.id == 'string') {
        if (val.id.length != 0) comp_require_num++;
      } else {
        comp_require_num++;
      }
    }

    let _newVal = val.value;
    if (key === 'charge_date') {
      _newVal = val.value.replace(/[^0-9]/g, '');
    }

    if ((type == 'update' || type == 'edit') && val.origin != _newVal) {
      edit_num++;
      edit_keys.push(key);
    } else {
      if (key == 'charge_date' && val.value_info) {
        edit_num++;
        edit_keys.push(key);
      }
    }
  }

  if (type == 'update' || type == 'edit') {
    if (data.presendday && data.charge_date && data.presendday.value === data.presendday.origin) {
      const _newVal = data.charge_date.origin.replace(/[^0-9]/g, '');
      if (_newVal !== data.charge_date.value) {
        edit_num + 2;
        edit_keys.push('presendday');
        edit_keys.push('charge_date');
      }
    }
  }
  // console.log(edit_keys);
  if (require_num == comp_require_num) {
    if (type == 'update' || type == 'edit') {
      if (edit_num > 0) {
        return { result: false, keys: edit_keys };
      } else {
        return { result: true, keys: [] };
      }
    } else {
      return { result: false, keys: edit_keys };
    }
  } else {
    return { result: true, keys: [], reason: 'NOT REQUIRED' };
  }
}

export function makeListUri(
  start: string,
  queries: { target?: string; sort?: string; page?: number; limit?: number; search_keyword?: string },
) {
  const { target, sort, page, limit, search_keyword } = queries;
  const items = [];
  if (target) items.push(`sort=${target}`);
  if (sort) items.push(`sortval=${sort}`);
  if (page) items.push(`page=${page}`);
  if (limit) items.push(`limit=${limit}`);
  if (search_keyword) items.push(`search_keyword=${escapeSpecialCharacter(search_keyword)}`);
  // 현재 필요x (일단 남겨둠)
  const uri = start + '?' + items.join('&');
  return uri;
}

// path validation
// 뒤에 가변적인 params가 들어올 때 2중 검증 필요 -> 추후 필요예상시 도입

interface PathType {
  [key: string]: { [key: string]: { [key: string]: { [key: string]: object } } };
}

const paths: PathType = {
  student: {
    teacher: {
      edit: {
        edit2: {},
      },
    },
    class: {
      edit: {},
    },
    list: {
      edit: {},
    },
    registration: {},
    counsel: {},
    study: {
      edit: {},
    },
  },
  attendance: {
    status: {},
    check: {},
    manager: {},
    sms: {},
    covid: {},
  },
  account: {
    check: {},
    manage: {},
    create: {},
    statistics: {},
    calculate: {},
    sms: {},
    download: {},
    'toss-manager': {},
  },
  sms: {
    send: {},
    detail: {},
    reservation: {},
  },
  setup: {
    info: {},
    phone: {},
    receipt: {},
    check: {},
    service: {},
    product: {},
  },
  cash: {
    charge: {},
    'charge-detail': {},
    'use-detail': {},
  },
  covid: {
    record: {},
  },
  magazine: {},
};

export function validationPath(currentUrl: string): boolean {
  const current_url_array = currentUrl.split(`${BASE_URL}/`);
  const current_url_depth = current_url_array.length - 1;

  if (currentUrl === '/') return true;
  let target: { [key: string]: any } = {};
  for (let idx = 1; idx <= current_url_depth; idx++) {
    if (idx == 1) {
      target = paths[current_url_array[idx]];
    } else {
      target = target[current_url_array[idx]];
    }
  }

  if (target) {
    return true;
  } else {
    return false;
  }
}

//
// 머문시간 구하는 함수 (stay_time)
export function calculateStayTime(start_time: string, end_time: string): string {
  const start_time_array = start_time.split(':');
  const end_time_array = end_time.split(':');
  // 정규식 이용해 먼저 시간인지 확인 아니면 바로 '-'
  const time_format = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
  if (time_format.test(start_time) && time_format.test(end_time)) {
    if (start_time_array.length === 2 && end_time_array.length === 2) {
      if (
        Number(start_time_array[0]) > Number(end_time_array[0]) ||
        (Number(start_time_array[0]) === Number(end_time_array[0]) &&
          Number(start_time_array[1]) > Number(end_time_array[1]))
      ) {
        return '-';
      } else {
        const stay_time_array = end_time_array.map(
          (item, index) => Number(end_time_array[index]) - Number(start_time_array[index]),
        );
        if (stay_time_array[1] < 0) {
          stay_time_array[0] = stay_time_array[0] - 1;
          if (stay_time_array[0] === 0) return `${60 + stay_time_array[1]}분`;
          else return `${stay_time_array[0]}시간 ${60 + stay_time_array[1]}분`;
        } else if (stay_time_array[1] === 0) {
          if (stay_time_array[0] === 0) return `${stay_time_array[1]}분`;
          else return `${stay_time_array[0]}시간`;
        } else {
          if (stay_time_array[0] === 0) return `${stay_time_array[1]}분`;
          else return `${stay_time_array[0]}시간 ${stay_time_array[1]}분`;
        }
      }
    } else {
      return '-';
    }
  } else {
    return '-';
  }
}

// modal_confrim title 가변적으로 만드는 함수
export function makeDateTitle(date_array: string[]): string {
  return `${date_array[1]}월 ${date_array[2]}일 출결 현황을 조회하시겠습니까?`;
}

export function makeModalSmsTarget(id: number, default_type: string): string {
  let target = '';
  switch (true) {
    case [1].includes(id):
      target = '등원 ';
      if (default_type === 'S') target += '메시지가';
      else target += '알림톡이';
      break;
    case [2].includes(id):
      target = '하원';
      if (default_type === 'S') target += '메시지가';
      else target += '알림톡이';
      break;
    case [3].includes(id):
      target = '지각';
      if (default_type === 'S') target += '메시지가';
      else target += '알림톡이';
      break;
    case [4].includes(id):
      target = '결석';
      if (default_type === 'S') target += '메시지가';
      else target += '알림톡이';
      break;
    case [5].includes(id):
      target = '일괄 등원처리';
      break;
    case [6].includes(id):
      target = '일괄 하원처리';
      break;
    case [7].includes(id):
      target = '일괄 지각처리';
      break;
    case [8].includes(id):
      target = '일괄 결석처리';
      break;
  }
  return target;
}

export function makeHourMinute() {
  const today = new Date();

  const hours = today.getHours();
  const minutes: string | number = today.getMinutes();
  if (hours < 10) {
    if (minutes < 10) return '0' + hours + ':' + '0' + minutes;
    else return '0' + hours + ':' + minutes;
  } else {
    if (minutes < 10) return hours + ':' + '0' + minutes;
    else return hours + ':' + minutes;
  }
}

export function getAfterMonth(date: string, resverse?: boolean) {
  const date_array = date.split('-');

  const req_year = Number(date_array[0]);
  const req_month = Number(date_array[1]);

  const this_year = new Date().getFullYear();
  const this_month = new Date().getMonth() + 1;

  const res_arr = [];
  if (resverse) {
    for (let i = this_year, leng = req_year; i >= leng; i--) {
      let target_month = req_month;
      let target_leng = 12;
      if (i != req_year) {
        target_month = 1;
      }
      if (i == this_year) {
        target_leng = this_month;
      }
      for (let j = target_leng; j >= target_month; j--) {
        res_arr.push(`${i}년 ${j < 10 ? '0' + j : j}월`);
      }
    }
  } else {
    for (let i = req_year, leng = this_year; i <= leng; i++) {
      let target_month = req_month;
      let target_leng = 12;
      if (i != req_year) {
        target_month = 1;
      }
      if (i == this_year) {
        target_leng = this_month;
      }
      for (let j = target_month; j <= target_leng; j++) {
        res_arr.push(`${i}년 ${j < 10 ? '0' + j : j}월`);
      }
    }
  }

  return res_arr;
}

export function makeMonthDateDay(date: string) {
  const date_array = date.split('-');
  date_array.splice(0, 1);
  const month = date_array[0][0] === '0' ? date_array[0][1] : date_array[0];
  const day = date_array[1][0] === '0' ? date_array[1][1] : date_array[1];

  const week = ['일', '월', '화', '수', '목', '금', '토'];
  const dayOfWeek = week[new Date(date).getDay()]; // 요일
  return `${month}월 ${day}일 (${dayOfWeek})`;
}

export function getIdRCheckday(rcheckday: string) {
  const rcheckday_arr = rcheckday.split(', ').filter(item => item);

  const days: { [key: string]: string } = {
    일: '0',
    월: '1',
    화: '2',
    수: '3',
    목: '4',
    금: '5',
    토: '6',
  };

  return rcheckday_arr.map(item => days[item]).toString();
}

export function makePhoneNumber(cur_phone_number: string) {
  let phone_number = `${cur_phone_number}`.trim();
  if (phone_number.includes('-')) phone_number = phone_number.split('-').join('');
  const condition = phone_number.length === 10;

  if (phone_number.substring(0, 2) === '02') {
    const first_digit = phone_number.substring(0, 2);
    const second_digit = condition ? phone_number.substring(2, 6) : phone_number.substring(2, 5);
    const third_digit = condition ? phone_number.substring(6) : phone_number.substring(5);
    return `${first_digit}-${second_digit}-${third_digit}`;
  } else if (cur_phone_number.length === 8) {
    return `${phone_number.substring(0, 4)}-${phone_number.substring(4, 8)}`;
  } else {
    const first_digit = phone_number.substring(0, 3);
    const second_digit = condition ? phone_number.substring(3, 6) : phone_number.substring(3, 7);
    const third_digit = condition ? phone_number.substring(6) : phone_number.substring(7);
    return `${first_digit}-${second_digit}-${third_digit}`;
  }
}

export function autoHypenPhone(str: string) {
  str = str.replace(/[^0-9]/g, '');
  let tmp = '';
  if (str.length < 4) {
    return str;
  } else if (str.length < 7) {
    tmp += str.substr(0, 3);
    tmp += '-';
    tmp += str.substr(3);
    return tmp;
  } else if (str.length < 11) {
    tmp += str.substr(0, 3);
    tmp += '-';
    tmp += str.substr(3, 3);
    tmp += '-';
    tmp += str.substr(6);
    return tmp;
  } else {
    tmp += str.substr(0, 3);
    tmp += '-';
    tmp += str.substr(3, 4);
    tmp += '-';
    tmp += str.substr(7);
    return tmp;
  }
}

export function setAccountNumber(account_number: string) {
  return account_number.replace(/^(\d{3})(\d{6})(\d{2})(\d{3})$/, `$1-$2-$3-$4`);
}

export function setDateFormat(current_date: string) {
  return current_date.replace(/^(\d{4})(\d{2})(\d{2})$/, `$1-$2-$3`);
}

export function setBusinessNumber(business_number: string) {
  return business_number
    .replace(/[^0-9]/g, '')
    .replace(/^(\d{0,3})(\d{0,2})(\d{0,5})$/g, '$1-$2-$3')
    .replace(/(\-{1,2})$/g, '');
}

export function makeMinuteContents() {
  const minute_array = [];
  let id = 0;
  for (let i = 0; i <= 59; i++) {
    if (i % 5 != 0) continue;
    const obj = { id: 0, label: '' };
    obj.id = id;
    if (i < 10) obj.label = `0${i}분`;
    else obj.label = `${i}분`;
    minute_array.push(obj);
    id++;
  }
  return minute_array;
}

export function makeHourContents() {
  const hour_array = [];
  for (let i = 0; i < 24; i++) {
    const obj = { id: 0, label: '' };
    obj.id = i;
    if (i < 10) {
      obj.label = `0${i}시`;
    } else {
      obj.label = `${i}시`;
    }
    hour_array.push(obj);
  }
  return hour_array;
}

export function checkTableQueries(table_query: TableQueryType) {
  const { target, sort, page, max } = table_query;

  if (target == '' && sort == '' && page == 1 && max == getListNum()) {
    return false;
  } else {
    return true;
  }
}

export function setPhoneFormat(phone: string) {
  const cur_phone = `${phone}`.trim();
  if (cur_phone.slice(0, 2) == '02') {
    return `${cur_phone}`.replace(/^(\d{2})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  } else {
    return `${cur_phone}`.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
}

export function setDateHypen(phone: string) {
  const cur_phone = `${phone}`.trim();
  return `${cur_phone}`.replace(/^(\d{4})(\d{2})(\d{2})$/, `$1-$2-$3`);
}

export function makeYearMonth(date: string): string {
  const date_array = date.split('-');
  return `${date_array[0]}년 ${date_array[1]}월`;
}

export function getByte(str: string) {
  let msg = str.replace(/\r\n/g, '\n');
  msg = msg.replace(/{학생명}/g, '홍길동');
  msg = msg.replace(/{이름}/g, '홍길동');
  msg = msg.replace(/{시간}/g, 'OO시 OO분');
  msg = msg.replace(/\n/g, '.');
  return msg
    .split('')
    .map(s => s.charCodeAt(0))
    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
}

export function getYearArray(date: string): string[] {
  const year_arr = [];
  const start_year = +date.split('-')[0];
  for (let i = new Date().getFullYear(); i >= start_year; i--) {
    year_arr.push(String(i) + '년');
  }
  return year_arr;
}

export function getMonthArray(date: string, year: string | number): string[] {
  const month_arr = [];
  let max_month: number;
  let start_month: number;
  const start_year = +date.split('-')[0];
  const current_year = +year;
  if (current_year == start_year) {
    start_month = +date.split('-')[1];
    if (current_year == new Date().getFullYear()) {
      max_month = new Date().getMonth() + 1;
      for (let i = max_month; i >= start_month; i--) {
        month_arr.push(`${i < 10 ? '0' + i + '월' : i + '월'}`);
      }
    } else {
      for (let i = 12; i >= start_month; i--) {
        month_arr.push(`${i < 10 ? '0' + i + '월' : i + '월'}`);
      }
    }
  } else {
    if (current_year == new Date().getFullYear()) max_month = new Date().getMonth() + 1;
    else max_month = 12;
    for (let i = max_month; i >= 1; i--) {
      month_arr.push(`${i < 10 ? '0' + i + '월' : i + '월'}`);
    }
  }
  return month_arr;
}

export function comparePostDate(class_post_date: string, student_post_date: string): boolean {
  const class_year = +class_post_date.split('-')[0];
  const student_year = +student_post_date.split('-')[0];
  if (class_year < student_year) {
    return true;
  } else if (class_year === student_year) {
    const class_month = +class_post_date.split('-')[1];
    const student_month = +student_post_date.split('-')[1];
    if (class_month < student_month) {
      return true;
    } else if (class_month === student_month) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
  // true면 클래스가 빠른거
  // false면 학생이 빠른거
  // 월까지 비교 후 같으면 학생의 post_date 기준으로 세팅
}

export function getDivisionKor(division: string) {
  let res = '';

  if (division == 'direct') {
    res = '수동';
  } else if (division == 'attendance') {
    res = '출결';
  } else if (division == 'temperature') {
    res = '체온';
  } else if (division == 'account') {
    res = '수납';
  } else if (division == 'counsel') {
    res = '상담';
  } else {
    res = '기타';
  }

  return res;
}

export function sortingBirthday(birth_list: BirthdayItemType[]) {
  //
}

export function makeBirthdayItem(birth_item: BirthdayItemType) {
  //
}

export function makeSmsDetailButtonDate(gap: number): { start: string; end: string } {
  let start: string;
  let end: string;
  const d = new Date(); // test 인자
  const after_one_date = 1000 * 60 * 60 * 24;
  const lastDayofLastMonth = new Date(d.getFullYear(), d.getMonth() - gap, 0).getDate();
  const lastDayofNowMonth = new Date(d.getFullYear(), d.getMonth() - gap + 1, 0).getDate();
  if (d.getDate() === new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()) {
    const d = new Date(); // 말일만 test 인자
    d.setDate(1);
    d.setMonth(d.getMonth() - gap);
    const start_date = new Date(d);
    d.setDate(lastDayofNowMonth);
    const end_date = new Date(d);
    start = setLocaleDateString(start_date, '-');
    end = setLocaleDateString(end_date, '-');
  } else {
    let d = new Date(); // test 인자
    if (lastDayofNowMonth > lastDayofLastMonth && d.getDate() >= lastDayofLastMonth) {
      d.setDate(lastDayofLastMonth);
      d.setMonth(d.getMonth() - gap - 1);
      const start_date = new Date(new Date(d).getTime() + after_one_date);
      d = new Date(); // test 인자
      d.setDate(d.getDate());
      d.setMonth(d.getMonth() - gap);
      const end_date = new Date(d);
      start = setLocaleDateString(start_date, '-');
      end = setLocaleDateString(end_date, '-');
    } else {
      d.setDate(d.getDate());
      d.setMonth(d.getMonth() - gap - 1);
      const start_date = new Date(new Date(d).getTime() + after_one_date);
      if (lastDayofNowMonth == 28) {
        if (d.getDate() >= lastDayofNowMonth) {
          d.setDate(lastDayofNowMonth);
        }
      }
      d.setMonth(d.getMonth() + 1);
      const end_date = new Date(new Date(d));
      start = setLocaleDateString(start_date, '-');
      end = setLocaleDateString(end_date, '-');
    }
  }
  return { start, end };
}

export function makeFontSize(
  font_size_obj: { [key: string]: boolean },
  default_font_size: number,
  property: string,
  font?: boolean,
): { [key: string]: string } {
  let new_font_size = '';
  const font_obj: { [key: string]: string } = {};
  for (const font_size in font_size_obj) {
    if (font_size_obj[font_size]) {
      new_font_size = font_size;
      break;
    }
  }
  if (new_font_size == 'default') {
    font_obj[property] = default_font_size + `${font ? 'rem' : '%'}`;
  } else if (new_font_size == 'small') {
    font_obj[property] = default_font_size * 0.8 + `${font ? 'rem' : '%'}`;
  } else {
    font_obj[property] = default_font_size * 1.2 + `${font ? 'rem' : '%'}`;
  }
  return font_obj;
}

export function getDateDiff(day: string): string {
  const date1 = new Date();
  const date2 = new Date(day);

  const diffDate = date1.getTime() - date2.getTime();
  return `${Math.ceil(diffDate / (1000 * 60 * 60 * 24))}일`;
}

export function getTotalStudyCount(dayArray: string[], year: number, month: number): string {
  let count = 0;
  const total_date = new Date(year, month, 0).getDate();
  for (let i = 1; i <= total_date; i++) {
    if (dayArray.includes(String(new Date(year, month, i).getDay()))) count++;
  }
  return `(전체 ${count}일)`;
}

export function getListNum() {
  return JSON.parse(`${window.localStorage.getItem('list_num')}`)[location.pathname];
}

export function getLeftMessageCount(smsCnt: number, isTable?: boolean): string | { type: string; label: string } {
  if (smsCnt >= 0) return `${makeCommaAsThousandSeparator(smsCnt)}건`;
  else {
    if (isTable)
      return {
        type: 'color-#ff382a',
        label: `${makeCommaAsThousandSeparator(Math.abs(smsCnt))}건 초과`,
      };
    else return `${makeCommaAsThousandSeparator(Math.abs(smsCnt))}건 초과`;
  }
}

export const setLoginUserInfo = (info: UserResponse): UserType => {
  const sms_att_msg_splited = info.attendance_sms_att_msg ? info.attendance_sms_att_msg.split('\r\n') : null;
  const sms_abs_msg_splited = info.attendance_sms_abs_msg ? info.attendance_sms_abs_msg.split('\r\n') : null;

  const sms_att_msg = sms_att_msg_splited
    ? sms_att_msg_splited.filter((item, item_idx) => item_idx != 0).join('')
    : null;
  const sms_abs_msg = sms_abs_msg_splited
    ? sms_abs_msg_splited.filter((item, item_idx) => item_idx != 0).join('')
    : null;

  const account_sms_msg = !info.account_sms ? account_sms_default : info.account_sms_msg;

  const mobile_exp = new RegExp(
    'Android|webOS|iPhone|iPad|' + 'BlackBerry|Windows Phone|' + 'Opera Mini|IEMobile|Mobile',
    'i',
  );

  let is_mobile = false;
  if (navigator && navigator.userAgent && mobile_exp.test(navigator.userAgent)) {
    is_mobile = true;
  }

  let notice_lms = true;
  if (info.transfer_date && info.alimtalkuse && info.alimtalkuse.data && info.alimtalkuse.data[0] < 2) {
    let test_title = '';
    let test_att = '';
    let test_abs = '';
    if (info.attendance_sms_att_msg && info.attendance_sms_abs_msg && sms_att_msg_splited) {
      test_title = sms_att_msg_splited[0];
      test_att = info.attendance_sms_att_msg;
      test_abs = info.attendance_sms_abs_msg;
    } else {
      test_title = `${info.cname} 등하원 안내`;
      test_att = drop_contents_start[0].label.replace(/OOO/gi, '홍길동').replace(/OO시 OO분/gi, '12시 00분');
      test_abs = drop_contents_end[0].label.replace(/OOO/gi, '홍길동').replace(/OO시 OO분/gi, '12시 00분');

      test_att = `${test_title}\r\n${test_att}`;
      test_abs = `${test_title}\r\n${test_abs}`;
    }

    if (getByte(test_att) > 80 || getByte(test_abs) > 80 || test_title.length > 18) {
      notice_lms = false;
    }
  }

  const table_keys = Object.keys(TableTypeKeys).filter(key => isNaN(Number(key))) as Array<keyof typeof TableTypeKeys>;
  const tableSort: any = {};
  table_keys.forEach(table_key => {
    let sortKey = null;
    let sortValue = null;

    const table_sortingValue = info[table_key];
    if (table_sortingValue && typeof table_sortingValue == 'string') {
      const split_value = table_sortingValue.split('::');
      sortKey = split_value[0];
      sortValue = split_value[1];
    }

    tableSort[table_key] = {
      sortKey,
      sortValue,
    };
  });

  const funnel_tutorial: FunnelTutorialType = {
    ft_postdate: typeof info.ft_postdate === 'string' ? info.ft_postdate : null,
    tutorial_stage: typeof info.tutorial_stage === 'number' ? info.tutorial_stage : 0,
  };

  const payload: UserType = {
    uid: info.uid,
    cid: info.cid,
    uclass: info.uclass,
    uname: info.uname,
    alimtalkuse: info.alimtalkuse.data[0],
    appreviewdone: info.appreviewdone,
    bepaid: info.bepaid,
    checkmoney: info.checkmoney,
    memtype: info.memtype,
    postdate: info.postdate,
    smscnt: info.smscnt,
    smsok: info.smsok.data[0],
    smsstop: info.smsstop,
    ubirth: info.ubirth,
    uloginid: info.uloginid,
    uphone: info.uphone,
    attendancesms: info.attendancesms,
    cname: info.cname,
    pass: true,
    phone: info.phone,
    cell: info.cell,
    attendance_alim_abs: info.attendance_alim_abs,
    attendance_alim_att: info.attendance_alim_att,
    attendance_alim_title: info.attendance_alim_title,
    attendance_sms_abs: info.attendance_sms_abs,
    attendance_sms_att: info.attendance_sms_att,
    attendance_alim_absence: info.attendance_alim_absence,
    attendance_sms_absence: info.attendance_sms_absence,
    attendance_absence_time: info.attendance_absence_time,
    account_alim_contents: info.account_alim_contents,
    account_alim_costday: info.account_alim_costday,
    account_alim_direct: info.account_alim_direct,
    account_alim_direct_msg: info.account_alim_direct_msg,
    account_first_time: info.account_first_time,
    account_second_date: info.account_second_date,
    account_second_time: info.account_second_time,
    account_second_notice: info.account_second_notice,
    use_attendance_msg: info.use_attendance_msg,
    attendance_sms_abs_msg: sms_abs_msg ?? '',
    attendance_sms_att_msg: sms_att_msg ?? '',
    attendance_sms_title: sms_att_msg_splited ? sms_att_msg_splited[0] : null,
    avaouttime: info.avaouttime,
    stdtime: info.stdtime,
    attendancemulti: info.attendancemulti,
    usehourformat: info.usehourformat,
    president: info.president,
    logofile: info.logofile,
    logofile_type: info.logofile_type,
    profile: info.profile,
    profile_type: info.profile_type,
    smsphone: info.smsphone,
    sms_err_status: info.sms_err_status,
    smsstartday: info.smsstartday,
    is_teacher: false,
    autosms: info.autosms,
    whenautosms: info.whenautosms,
    autosmscontent: info.autosmscontent,
    restime: info.restime,
    pwdate: info.pwdate,
    account_sms: info.account_sms,
    account_sms_msg: account_sms_msg,
    product_change_status: info.product_change_status,
    free_end_date: setLocaleDateString(
      new Date(new Date(info.postdate).setTime(new Date(info.postdate).getTime() + 1000 * 60 * 60 * 24 * 7)),
      '-',
    ),
    current_list_num: 0,
    login: 1,
    pretest: ['pretest'].includes(info.uloginid) ? 1 : 0,
    transfer_date: info.transfer_date,
    is_mobile,
    notice_lms,
    account_registration: info.account_registration,
    account_provider: normalizeAccountProvider(info.account_provider),
    sp_pkid: info.sp_pkid,
    cost: info.cost,
    payment: info.payment,
    notice_payment: false,
    // 수납관리 (사업자 정보)
    account_phone: info.account_phone,
    account_number: info.account_number,
    business_number: info.business_number,
    ceo_name: info.ceo_name,
    customer: info.customer,
    bank: info.bank,
    // v2이면서 수납관리 사용자
    useaccount: info.useaccount,
    open_account: false,
    // 지출증빙 정보 미기입시 팝업 여부 (0: 안보이게, 1: 보이도록)
    notice_envidence: info.notice_envidence,
    open: info.open,
    account_before: info.account_before,
    account_before_date: info.account_before_date,
    account_before_time: info.account_before_time,
    mallkind: '',
    account_expire: info.account_expire,
    account_expire_time: info.account_expire_time,
    spam_notice: false,
    tableSort,
    isRequestUser: info.isRequestUser,
    // 화면 zoom 상태
    zoom_status: info.zoom_status,
    funnel_tutorial: { ...funnel_tutorial },
    first_paymentdate: info.first_paymentdate,
    recommend_code: info.recommend_code,
    absence_alim: info.absence_alim, // * 결석 안내
  };

  return payload;
};

export const sortingRcheckday = (rcheckday: string): string => {
  const weekday = ['월', '화', '수', '목', '금', '토', '일'];
  const rcheckday_arr: number[] = rcheckday.split(',').map((day, idx) => weekday.findIndex(element => element == day));
  rcheckday_arr.sort((a, b) => a - b);

  return rcheckday_arr.map((day, idx) => weekday[day]).join(', ');
};

export const validateKorean = (value: string): boolean => {
  const koreanPattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
  if (koreanPattern.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const validatePassword = (value: string): boolean => {
  let status = false;
  status = validateKorean(value);
  if (status) return false;
  else {
    const passwordPattern = /^[a-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]*$/;
    status = passwordPattern.test(value);
    if (status) {
      status = false;
      const p_num = value.search(/[0-9]/g);
      const p_spc = value.search(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+/g);
      const p_alp = value.search(/[a-z]/g);

      if (p_num > -1 && p_spc > -1) status = true;
      if (p_num > -1 && p_alp > -1) status = true;
      if (p_spc > -1 && p_alp > -1) status = true;
      if (p_num && p_spc > -1 && p_alp > -1) status = true;
      return status;
    } else {
      return status;
    }
  }
};

export const makeCommaAsThousandSeparator = (value: string | number): string => {
  return value.toLocaleString('ko-KR');
};

export const addClassInUsers = async (userInfo: UserType, item: TableItemsType) => {
  if (item && item.rid && item.details && !item.details.students) {
    const rid = item.rid;
    const res = await fetchGetApi(`/${userInfo.cid}/user/${userInfo.uid}/class/${rid}/inusers`);
    if (res.message != 'null') {
      const rows = res.message.rows;
      for (let i = 0, leng = rows.length; i < leng; i++) {
        let status = '';
        if (rows[i].uclass != 'S') {
          status = `(${getKorUclass(rows[i].uclass).label})`;
        }
        if (i > 0) item.details[`s${i}`] = `${rows[i].uname} ${status}`;
        else item.details.students = `${rows[i].uname} ${status}`;
      }
    } else {
      item.details.students = '등록된 학생이 없습니다.';
    }
  }
};

export const addClassInTeacher = async (userInfo: UserType, item: TableItemsType) => {
  if (item && item.uid && item.details && item.details.rname === null) {
    const uid = item.uid;
    const res = await fetchGetApi(`/${userInfo.cid}/user/${userInfo.uid}/teacher/${uid}/rooms`);
    if (res.message.rname) {
      item.details.rname = res.message.rname;
    } else {
      item.details.rname = '배정된 클래스가 없습니다.';
    }

    if (res.message.multi_rname) {
      item.details.multi_rname = res.message.multi_rname;
    }
  }
};

export const emptyCache = () => {
  // if ('caches' in window) {
  //   caches.keys().then(names => {
  //     // Delete all the cache files
  //     names.forEach(name => {
  //       caches.delete(name);
  //     });
  //   });

  // Makes sure the page reloads. Changes are only visible after you refresh.
  window.removeEventListener('beforeunload', beforeUnLoadFunction);
  window.location.reload();
  // }
};

export const beforeUnLoadFunction = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = '';
};

export const makeAreaChartHour = (time: string | number) => {
  let hour = '';
  const string_time = String(time);
  if (string_time.length > 3) {
    hour = string_time.substring(0, 2);
  } else {
    hour = '0' + string_time.substring(0, 1);
  }
  return hour;
};

export const makeAreaChartMinute = (time: string | number) => {
  let minute = '';
  const string_time = String(time);
  minute = string_time.substring(2, 4);
  return minute;
};

export const makeDatetime = (dateTime: Date): string => {
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1 < 10 ? `0${dateTime.getMonth() + 1}` : dateTime.getMonth() + 1;
  const date = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate();
  const hour = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours();
  const minute = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes();
  const second = dateTime.getSeconds() < 10 ? `0${dateTime.getSeconds()}` : dateTime.getSeconds();
  return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
};

export const makeExpirationDatetime = (dateTime: string): string => {
  const complete_dateTime = new Date(dateTime);
  const tmp_dateTime = new Date(
    new Date(complete_dateTime.setDate(complete_dateTime.getDate() - 1)).setHours(23, 59, 59),
  );
  const expiration_dateTime = makeDatetime(tmp_dateTime);
  return expiration_dateTime;
};

export const makePreviewModalDateTime = (): string => {
  let previewModaldateTime = '';
  const obj_date = new Date();
  const year = obj_date.getFullYear();
  const month = toStringMonthOrDate(obj_date.getMonth() + 1);
  const day = toStringMonthOrDate(obj_date.getDate());
  previewModaldateTime = `${year}-${month}-${day} 10:00`;
  return previewModaldateTime;
};

export const toStringMonthOrDate = (monthOrDate: number): string => {
  let string_monthOrDate = String(monthOrDate);
  if (string_monthOrDate.length === 1) {
    string_monthOrDate = `0${string_monthOrDate}`;
  }
  return string_monthOrDate;
};

export const retryLazy = (componentImport: any) =>
  lazy(async () => {
    const pageAlreadyRefreshed = JSON.parse(window.localStorage.getItem('pageRefreshed') || 'false');
    try {
      const component = await componentImport();
      window.localStorage.setItem('pageRefreshed', 'false');
      // console.log('success');
      return component;
    } catch (error) {
      console.log('failed', error);
      if (!pageAlreadyRefreshed) {
        window.removeEventListener('beforeunload', beforeUnLoadFunction);
        window.localStorage.setItem('pageRefreshed', 'true');
        return window.location.reload();
      }
      throw error;
    }
  });

export const checkBrowser = () => {
  const agent = window.navigator.userAgent.toLowerCase();
  let browserName: string;
  switch (true) {
    case agent.indexOf('edge') > -1:
      browserName = 'MS Edge'; // MS 엣지
      break;
    case agent.indexOf('edg/') > -1:
      browserName = 'Edge (chromium based)'; // 크롬 기반 엣지
      break;
    case agent.indexOf('opr') > -1 && !!(window as any).opr:
      browserName = 'Opera'; // 오페라
      break;
    case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
      browserName = 'Chrome'; // 크롬
      break;
    case agent.indexOf('trident') > -1:
      browserName = 'MS IE'; // 익스플로러
      break;
    case agent.indexOf('firefox') > -1:
      browserName = 'Mozilla Firefox'; // 파이어 폭스
      break;
    case agent.indexOf('safari') > -1:
      browserName = 'Safari'; // 사파리
      break;
    default:
      browserName = 'other'; // 기타
  }
  return browserName;
};

export const printIframe = (print_iframe: HTMLIFrameElement) => {
  const browserName = checkBrowser();
  if (browserName === 'Safari') {
    // 사파리 예외 처리
    const printSafari = () => {
      const popup = window.open('', '_blank', 'width=1,height=1');
      if (popup && print_iframe) {
        popup?.addEventListener('afterprint', () => {
          popup.close();
        });
        popup.document.head.innerHTML = print_iframe.contentWindow?.document.head.innerHTML as string;
        popup.document.body.innerHTML = print_iframe.contentWindow?.document.body.innerHTML as string;
      }
      setTimeout(() => {
        popup?.print();
        setTimeout(() => {
          popup?.close();
        }, 200);
      }, 200);
    };
    printSafari();
  } else {
    setTimeout(() => {
      print_iframe.contentWindow?.print();
      const body = document.getElementsByTagName('body')[0];
      body.removeChild(print_iframe);
    }, 1000);
  }
};

export const makeChartResponsivePrintStyle = (pieLayoutOtions: PieChartResponsiveVariable): string => {
  const { pie, cell, area } = pieLayoutOtions;
  const { top: pie_top, scale: pie_scale, left: pie_left } = pie;
  const { top: cell_top, scale: cell_scale, left: cell_left } = cell;
  const { paddingTop: area_paddingTop, marginBottom: area_marginBottom } = area;

  const pieChartPrintStyle = `
    #analyze_wrap > div:first-child > div:last-child > div > div:first-child {
        top: ${pie_top}% !important;
        transform: scale(${pie_scale}) !important;
        left: ${pie_left}% !important;
      }
    #analyze_wrap > div:first-child > div:last-child > div > div:last-child {
      top: ${cell_top}% !important;
      transform: scale(${cell_scale}) !important;
      left: ${cell_left}% !important;
    }
    #analyze_wrap > div:nth-child(3),
    #analyze_wrap > div:last-child {
      padding-top: ${area_paddingTop}px;
    }
    #analyze_wrap > div:nth-child(3) > div:first-child,
    #analyze_wrap > div:last-child > div:first-child {
      margin-bottom: ${area_marginBottom}px;
    }
  `;
  return pieChartPrintStyle;
};

export const setResponsiveOptions = (viewport: number): PieChartResponsiveVariable => {
  const originalResponsiveOptions: PieChartResponsiveVariable = {
    pie: {
      top: 15,
      scale: 0,
      left: 0,
    },
    cell: {
      top: 0,
      scale: 0,
      left: 0,
    },
    area: {
      paddingTop: 13,
      marginBottom: -6,
    },
  };
  switch (true) {
    case viewport > 1904:
      originalResponsiveOptions.pie.scale = 1.15;
      originalResponsiveOptions.pie.left = 16;

      originalResponsiveOptions.cell.top = 13;
      originalResponsiveOptions.cell.scale = 1.05;
      originalResponsiveOptions.cell.left = 17.75;
      break;
    case viewport > 1770:
      originalResponsiveOptions.pie.scale = 1.35;
      originalResponsiveOptions.pie.left = 16.5;

      originalResponsiveOptions.cell.top = 13;
      originalResponsiveOptions.cell.scale = 1.05;
      originalResponsiveOptions.cell.left = 17.75;
      break;
    case viewport > 1574:
      originalResponsiveOptions.pie.scale = 1.35;
      originalResponsiveOptions.pie.left = 11.5;

      originalResponsiveOptions.cell.top = 13;
      originalResponsiveOptions.cell.scale = 1.05;
      originalResponsiveOptions.cell.left = 17;
      break;
    case viewport > 1383:
      originalResponsiveOptions.pie.scale = 1.35;
      originalResponsiveOptions.pie.left = 9.5;

      originalResponsiveOptions.cell.top = 14;
      originalResponsiveOptions.cell.scale = 1.25;
      originalResponsiveOptions.cell.left = 21;
      break;
    case viewport > 1197:
      originalResponsiveOptions.pie.scale = 1.65;
      originalResponsiveOptions.pie.left = 9.125;

      originalResponsiveOptions.cell.top = 14;
      originalResponsiveOptions.cell.scale = 1.4;
      originalResponsiveOptions.cell.left = 22;
      break;
    case viewport > 767:
      originalResponsiveOptions.pie.scale = 1.65;
      originalResponsiveOptions.pie.left = 8.85;

      originalResponsiveOptions.cell.top = 14;
      originalResponsiveOptions.cell.scale = 1.475;
      originalResponsiveOptions.cell.left = 24.25;
      break;
    default:
      originalResponsiveOptions.pie.scale = 1.65;
      originalResponsiveOptions.pie.left = 10.5;

      originalResponsiveOptions.cell.top = 14;
      originalResponsiveOptions.cell.scale = 1.475;
      originalResponsiveOptions.cell.left = 24.5;
      break;
  }
  const browserName = checkBrowser();
  if (browserName === 'Safari') {
    originalResponsiveOptions.pie.top -= 12;
    originalResponsiveOptions.pie.scale -= 0.1;

    originalResponsiveOptions.cell.top -= 12;
    originalResponsiveOptions.cell.left += 1;

    originalResponsiveOptions.area.paddingTop -= 5;
    originalResponsiveOptions.area.marginBottom -= 9;
  }

  return originalResponsiveOptions;
};

export const escapeSpecialCharacter = (keyword: string) => {
  const encode_keyword: string = encodeURIComponent(keyword);
  return encode_keyword;
};

export const processingPaymentState = (state: string, kind?: string, deleted_date?: string, called?: string) => {
  const label = state;
  if (state === '결제대기') {
    return { type: 'content', label };
  } else if (state === '결제완료') {
    if (['카드', '간편결제'].includes(`${kind}`) || (called && ['manage', 'statistics'].includes(called))) {
      return { type: 'content', label };
    } else {
      return { type: 'color #2c7cd8', label };
    }
  } else if (state === '결제취소') {
    return { type: 'color red', label };
  } else if (state === '청구취소') {
    return { type: 'color #e1e2e3', label };
  } else if (state === '납부만료') {
    return { type: 'content', label: '납부만료' };
  } else {
    if (deleted_date && deleted_date != '1001-01-01 00:00:00') {
      return { type: 'color #e1e2e3', label: '청구취소' };
    } else {
      return { type: 'color #e1e2e3', label: '청구대기' };
    }
  }
};

export const processingPaymentDate = (state: string, date: string, isDate?: boolean) => {
  if (date) {
    let label = date;
    if (isDate) {
      label = label.split(' ')[0];
    }
    if (state === '결제대기') {
      return { type: 'color black', label };
    } else if (state === '결제완료') {
      return { type: 'color #2c7cd8', label };
    } else if (state === '결제취소') {
      return { type: 'color red', label };
    } else if (state === '청구취소') {
      return { type: 'color #e1e2e3', label };
    } else if (state === '청구대기') {
      return { type: 'color #e1e2e3', label };
    } else if (state === '청구삭제') {
      return { type: 'color #e1e2e3', label };
    } else if (state === '납부만료') {
      return { type: 'color #e1e2e3', label };
    }
  } else {
    return '-';
  }
};

export const makeImmutabilityCreateDetail = (obj: { [key: string]: CreateDetail }): { [key: string]: CreateDetail } => {
  const return_obj: { [key: string]: CreateDetail } = {};
  const obj_keys = Object.keys(obj);
  for (let i = 0; i < obj_keys.length; i++) {
    const key = obj_keys[i];
    return_obj[key] = { ...obj[key] };
  }
  return return_obj;
};

export const changeNoticeDateTimeToDate = (dateTime: string): string => {
  if (dateTime) {
    // dateTime이 없으면 실행 x
    const no_dots_date_time = dateTime.replace(/\./g, '');
    const date_time_array = no_dots_date_time.split(' ');

    date_time_array.pop();

    const date_time_string = date_time_array.join('-');
    return date_time_string;
  } else {
    return '-';
  }
};

export const paymentDateToDateType = (paymentDate: string) => {
  const date_array = paymentDate.split('. ');
  return date_array.join('/');
};

export const getDueDate = (amountDay: string, period: string) => {
  const number_period = Number(period);
  const amount_day = amountDay.replace(/-/g, '/');
  const notice_date = new Date(amount_day);
  const due_date = new Date(notice_date.setDate(notice_date.getDate() + number_period - 1));

  return setLocaleDateString(due_date, '-');
};

export const setDomTitle = (className: string) => {
  const label_array = Array.from(document.getElementsByClassName(className)) as HTMLElement[];

  for (let i = 0; i < label_array.length; i++) {
    const label = label_array[i];
    if (label.offsetWidth < label.scrollWidth) {
      const title = (label.dataset.label as string) || '';
      label.setAttribute('title', title);
    } else {
      label.setAttribute('title', '');
    }
  }
};

export const makeErrorTextAndPlaceholder = (type: string) => {
  const type_obj: { [key: string]: { errorText: string; placeholder: string } } = {
    phone: {
      errorText: '올바른 휴대폰 번호를 입력해주세요.',
      placeholder: '번호를 입력하세요.',
    },
  };
  return type_obj[type];
};

export const changeNumberToWon = (price: number) => {
  return '₩ ' + makeCommaAsThousandSeparator(price) + '원';
};

export const checkLeapYear = (year: number) => {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
};

export const makeAutoBillingDate = (day: number, originDay?: number, thisMonthSend?: boolean | undefined): string => {
  const now = dayjs();
  const today = now.date();

  const isNew = originDay == null; // * 청구대상 생성
  const hasSentThisMonth = !!thisMonthSend;

  const shouldGoNextMonth =
    (!isNew && hasSentThisMonth) || // 기존 + 이번달 발송됨 => 무조건 다음달
    day < today; // 당일 포함 규칙

  const base = shouldGoNextMonth ? now.add(1, 'month') : now;

  // 말일 클램프
  const lastDay = base.endOf('month').date();
  const billingDay = Math.min(day, lastDay);

  const billing = base.date(billingDay);
  const auto_billing_date = billing.format('YYYY년 MM월 DD일');
  return `///( 자동 청구일 : ${auto_billing_date} )`;
};

export const templateButtonString = (op: string): string => {
  switch (op) {
    case 'academy':
      return '{학원명}';
    case 'name':
      return '{이름}';
    case 'student_name':
      return '{학생명}';
    case 'notice_date':
      return '{청구일}';
    case 'class':
      return '{클래스}';
    case 'end_date':
      return '{납부기한}';
    case 'amount':
      return '{청구금액}';
    case 'phone':
      return '{발신번호}';
    default:
      return '';
  }
};

export const templateButtonJumpCursor = (op: string): number => {
  switch (op) {
    case 'name':
      return 4;
    case 'academy':
      return 5;
    case 'student_name':
      return 5;
    case 'notice_date':
      return 5;
    case 'class':
      return 5;
    case 'end_date':
      return 6;
    case 'amount':
      return 6;
    case 'phone':
      return 6;
    default:
      return 0;
  }
};

export function processingMaxOrMin(maxOrMin: number, type: 'max' | 'min'): number {
  const variation = type === 'max' ? 1 : -1;
  let number_length = String(maxOrMin).length;
  let new_max_or_min: number;
  if (type === 'max') {
    new_max_or_min = Math.floor(maxOrMin / Math.pow(10, number_length - 1));
  } else {
    new_max_or_min = Math.ceil(maxOrMin / Math.pow(10, number_length - 1));
  }
  // 0이 있을경우를 위한 예외처리
  if (new_max_or_min === 0) {
    return new_max_or_min;
  }

  new_max_or_min += variation;
  if (new_max_or_min === 0) {
    // 1000만, 100만은 무조건 0만으로 나오는 예외 때문에 하는 처리
    new_max_or_min = 9;
    number_length--;
  }
  new_max_or_min = new_max_or_min * Math.pow(10, number_length - 1);
  return new_max_or_min;
}

export const makeStatusColor = (status: string) => {
  switch (status) {
    case '결제완료':
      return '#2c7cd8';
      return;
      break;
    case '결제취소':
      return '#e9121d';
      break;
    case '결제대기':
      break;
    default:
      return '#e1e2e3';
      break;
  }
};

export const makeCalculateExcelKeysAndStyles2 = (
  type: string,
): { excel_keys: { [key: string]: string }; excel_styles: { [key: string]: { width: number; center: boolean } } } => {
  if (type === 'list') {
    return {
      excel_keys: {
        no: '번호',
        payment_kind_origin: '결제수단',
        payment_date: '결제일',
        adjustment_date: '정산일',
        payment_amount: '결제금액',
        total_fee: '수수료',
        adjustment_amount: '정산금액',
        adjustment_result: '정산 여부',
        memo: '비고',
      },
      excel_styles: {
        no: { width: 8, center: true },
        payment_kind_origin: { width: 18, center: true },
        payment_date: { width: 18, center: true },
        adjustment_date: { width: 18, center: true },
        payment_amount: { width: 18, center: true },
        total_fee: { width: 18, center: true },
        adjustment_amount: { width: 18, center: true },
        adjustment_result: { width: 18, center: true },
        memo: { width: 67, center: true },
      },
    };
  } else {
    return {
      excel_keys: {
        no: '번호',
        complete_settle_type: '결제수단',
        rname: '클래스',
        uname: '이름',
        complete_date_time: '결제일',
        refund_date_time: '취소일',
        amount: '청구금액',
        pay_amount: '결제금액',
        memo: '비고',
      },
      excel_styles: {
        no: { width: 8, center: true },
        complete_settle_type: { width: 18, center: true },
        rname: { width: 30, center: true },
        uname: { width: 18, center: true },
        complete_date_time: { width: 18, center: true },
        refund_date_time: { width: 18, center: true },
        amount: { width: 18, center: true },
        pay_amount: { width: 18, center: true },
        memo: { width: 67, center: true },
      },
    };
  }
};

export const makeCalculateExcelKeysAndStyles = (): {
  excel_keys: { [key: string]: string };
  excel_styles: { [key: string]: { width: number; center: boolean; numFmt?: string } };
} => {
  return {
    excel_keys: {
      no: '번호',
      payment_kind_origin: '결제수단',
      payment_date: '결제일',
      adjustment_date: '정산일',
      payment_amount: '결제금액',
      total_fee: '수수료',
      adjustment_amount: '정산금액',
      adjustment_result: '정산 여부',
      memo: '비고',
    },
    excel_styles: {
      no: { width: 8, center: true },
      payment_kind_origin: { width: 18, center: true },
      payment_date: { width: 38, center: true },
      adjustment_date: { width: 18, center: true },
      payment_amount: { width: 18, center: true, numFmt: '"￦ "#,##0' },
      total_fee: { width: 18, center: true, numFmt: '"￦ "#,##0' },
      adjustment_amount: { width: 18, center: true, numFmt: '"￦ "#,##0' },
      adjustment_result: { width: 18, center: true },
      memo: { width: 67, center: true },
    },
  };
};

export const isKoreanCharacter = (char: string) => {
  return /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(char);
};
export const isSpaceCharacter = (char: string) => {
  return /^\s*$/g.test(char);
};

// * 링크 속하는지 비교
// * 맨 마지막 회차에 한글포함되어 있으면 안내문구 띄어주기
export const isIncludeLink = (text: string) => {
  const strArr = text.split(/\s+/);
  let urlCnt = 0;
  let linkIndex = 0;

  for (let i = 0; i < strArr.length; i++) {
    const value = strArr[i];
    // * 1. 한글지우기
    const withoutKorean = value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, ' ');

    // * 2. 앞뒤 공백 지우기
    const withoutSpace = withoutKorean.replace(/^\s*/, '');
    const withdoutSc = withoutSpace.replace(/\s.*$/, '');

    // * 3. 앞뒤 특수문자 지우기
    const trimmedString = withdoutSc.replace(/[^a-zA-Z0-9:/.]/g, '');

    const pattern = /^(https?:\/\/)?([\w\d-]+\.)+[\w]{2,}(\/[\w\d-._~:/?#[\]@!$&'()*+,;=%]*)?$/i;

    if (pattern.test(trimmedString)) {
      const isNumericWithDotsOnly = /^[\d.]+$/.test(trimmedString);
      if (!isNumericWithDotsOnly) {
        linkIndex = i;
        urlCnt++;
      }
    }
  }

  let isIncludeString = false;
  if (urlCnt > 0) {
    const target_str = strArr[linkIndex];
    isIncludeString = !/[a-zA-Z]/.test(target_str[target_str.length - 1]);
  }

  return isIncludeString;
};

// 각 날짜를 Date 객체로 변환하고 필터링
export const filteredMonth = (holidays: Array<string>, target_month: number) => {
  return holidays.filter(dateString => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    return month === target_month;
  });
};

// * 해당하는 년/월 알림뱅킹 해지일자 구하기
interface AlimTerminationUser {
  pretest?: number | string | null;
  uloginid?: string | null;
  account_provider?: AccountProvider;
}

export const shouldCheckAlimTermination = (user?: AlimTerminationUser | null) => {
  return isHyosungAccount(user) && Number(user?.pretest) !== 1 && user?.uloginid !== 'pretest';
};

export const getTerminateDate = async (year: number, month: number) => {
  const url = `/management/getAlimTerminateDate/${year}/${month}`;
  return await fetchGetApi(url);
};

export const getIsHoliday = async (year: number) => {
  const url = `{ims}/common/getHoliday/${year}/noMonth`;
  return await fetchGetApi(url);
};

const isWeekend = (date: Date) => {
  const day = date.getDay();
  return day === 0 || day === 6;
};

// * 영업일 구하기
export const getBusinessDay = (date: Date, holidays: string[]): Date => {
  const currentDate = new Date(date);

  while (isWeekend(currentDate) || holidays.includes(setLocaleDateString(currentDate, '-'))) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return currentDate;
};

export const getDefaultSortingTableQuery = ({
  tableSort,
  table_query_key,
}: {
  tableSort: TableSortListType;
  table_query_key: keyof typeof TableTypeKeys;
}): {
  target: string;
  sort: string;
  page: number;
  max: any;
} => {
  if (
    tableSort &&
    tableSort[table_query_key] &&
    tableSort[table_query_key].sortKey &&
    tableSort[table_query_key].sortValue
  ) {
    return {
      target: tableSort[table_query_key].sortKey as string,
      sort: tableSort[table_query_key].sortValue as string,
      page: 1,
      max: getListNum(),
    };
  } else {
    const default_sort = TableDefaultSortKey[table_query_key];
    return {
      target: default_sort.sortKey,
      sort: default_sort.sortValue,
      page: 1,
      max: getListNum(),
    };
  }
};

export const sortingTableWithTableQueryKey = ({
  tableSort,
  table_query_key,
  setTableQuery,
  sortKey,
  sortValue,
}: {
  tableSort: TableSortListType;
  table_query_key: keyof typeof TableTypeKeys;
  setTableQuery: (
    value: SetStateAction<{
      target: string;
      sort: string;
      page: number;
      max: any;
    }>,
  ) => void;
  sortKey?: string;
  sortValue?: string;
}) => {
  if (
    tableSort &&
    tableSort[table_query_key] &&
    tableSort[table_query_key].sortKey &&
    tableSort[table_query_key].sortValue
  ) {
    setTableQuery({
      target: tableSort[table_query_key].sortKey as string,
      sort: tableSort[table_query_key].sortValue as string,
      page: 1,
      max: getListNum(),
    });
  } else {
    const default_sort = TableDefaultSortKey[table_query_key];
    setTableQuery({
      target: sortKey ? sortKey : default_sort.sortKey,
      sort: sortValue ? sortValue : default_sort.sortValue,
      page: 1,
      max: getListNum(),
    });
  }
};

// * 12시간제로 변경
export const format12times = (time: string) => {
  const [hours, minutes] = time.split(':');

  let hoursInt = parseInt(hours, 10);
  const amOrPm = hoursInt >= 12 ? 'PM' : 'AM';

  hoursInt = hoursInt % 12;
  hoursInt = hoursInt ? hoursInt : 12; // 0시는 12시로 변환

  const formattedHours = hoursInt.toString().padStart(2, '0');
  return `${formattedHours}:${minutes} ${amOrPm}`;
};

// * YYYYMMDDHHMMSS 형식으로 변경
export const formatReserveTime = (date: string) => {
  return dayjs(date).format('YYYYMMDDHHmmss');
};

// * 10분 체크 하여 10분 이전일 경우 미래로 변환
export const check10minutes = (date: string, format: string) => {
  const now = dayjs();
  const target = dayjs(date);

  if (target.diff(now, 'minute') <= 10) {
    let adjustedTime = now.add(10, 'minute');

    const minutes = adjustedTime.minute();
    const roundedMinutes = 5 * Math.round(minutes / 5);
    adjustedTime = adjustedTime.minute(roundedMinutes).second(0);

    return adjustedTime.format(format);
  } else {
    return date;
  }
};

export const changeCalendarWeekdayName = (idx: number) => {
  switch (idx) {
    case 0:
      return 'Sun';
    case 1:
      return 'Mon';
    case 2:
      return 'Tue';
    case 3:
      return 'Wed';
    case 4:
      return 'Thu';
    case 5:
      return 'Fri';
    case 6:
      return 'Sat';
    default:
      return '';
  }
};

export const diffDay = (startdate: string, enddate: string) => {
  const start_dayjs = dayjs(startdate);
  const end_dayjs = dayjs(enddate);

  const duration = end_dayjs.diff(start_dayjs, 'days');
  return duration;
};

// * 효성 점검 여부 체크
export const isHyosungDisable = () => {
  const currentDate = dayjs();
  let endTimeStr = '';
  let isNeedDisable = false;
  for (let i = 0; i < HyosungDisabledDates.length; i++) {
    const disabledStartDate = dayjs(HyosungDisabledDates[i].startDate);
    const disabledEndDate = dayjs(HyosungDisabledDates[i].endDate);

    if (currentDate.isAfter(disabledStartDate) && currentDate.isBefore(disabledEndDate)) {
      isNeedDisable = true;
      endTimeStr = HyosungDisabledDates[i].endTimeStr;
    }
  }

  return { res: isNeedDisable, endTimeStr };
};

export const isVirtualAccountDisable = () => {
  const currentDate = dayjs();
  let isNeedDisable = false;
  for (let i = 0; i < VirtualAccountDisabledDates.length; i++) {
    const disabledStartDate = dayjs(VirtualAccountDisabledDates[i].startDate);
    const disabledEndDate = dayjs(VirtualAccountDisabledDates[i].endDate);

    if (currentDate.isAfter(disabledStartDate) && currentDate.isBefore(disabledEndDate)) {
      isNeedDisable = true;
    }
  }
  return isNeedDisable;
};

// * check funnel tutorial
export const checkFunnelTutorial = (funnel_obj: FunnelTutorialType, stage: number) => {
  if (!funnel_obj || !stage || funnel_obj.tutorial_stage !== stage) return false;
  return true;
};

// * update funnel tutorials
export const updateFunnelTutorials = async (cid: number, uid: number, type: string, value: number): Promise<any> => {
  if (!cid || !type || !value || !uid) {
    return new Promise(resolve => resolve({ pass: false }));
  }
  const updateFunnelRes = await fetchPostApi(`/${cid}/user/${uid}/academy/funneltutorial/${type}`, {
    value: value + 1,
  });
  return updateFunnelRes;
};
